import { Component, OnInit} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewRequestComponent } from './ui/newrequest/newrequest.component';
import { CancelRequestComponent } from './ui/cancelrequest/cancelrequest.component';
import { CompanyService } from '../company.service';
import { CommentsModalComponent } from '../comments-modal/comments-modal.component';
import { UserRequestService } from './data-access/requests.service';
import { formatDate } from './data-access/date-format';
import { Router } from '@angular/router';

@Component({
    selector: 'app-requests',
    templateUrl: './requests.component.html',
    styleUrls: ['./requests.component.scss'],
    standalone: false
})
export class RequestsComponent implements OnInit {
  commentsloaded: Promise<boolean>;
  prfyear: number;
  groupcode: string;
  custname: string;
  prfuser: string;
  isLoading: boolean = true;
  skeletonHeaders = Array(1).fill(null);
  skeletonRows = Array(10).fill(null);
  data = [];
  expandedRowIndex: number | null = null;

  ngOnInit(): void {
    this.prfyear = parseInt(localStorage.getItem('year'));
    this.groupcode = localStorage.getItem('groupcode');
    this.companyService.getgroupname().subscribe((name: string) => {
      this.custname = name;
    });
    this.prfuser = this.companyService.userid;
    this.loadRequests();
  }

  displayedColumns: string[] = [
    'slNo',
    'companyName',
    'prfNumber',
    'type',
    'createdAt',
    'updaedAt',
    'status',
    'action',
  ];

  constructor(
    private modalService: NgbModal,
    private companyService: CompanyService,
    private requestService: UserRequestService,
    private router: Router,
  ) {}

  loadRequests(): void {
    this.isLoading = true;
    const payload = {
      prfyear: this.prfyear,
      groupcode: this.groupcode,
      pagesize: 100,
    };
    this.requestService.getUserRequestList(payload).subscribe({
      next: (response: { data: { ticketslist: any[] } }) => {
        this.data = response.data.ticketslist || [];
        if (this.data.length !== 0) {
          this.skeletonRows = Array(this.data.length).fill(null);
          setTimeout(() => {
            this.isLoading = false;
          }, 500)
        }	 else {
          this.isLoading = false;
        }
      },
      error: (error) => {
        console.error('Error loading requests:', error);
        this.isLoading = false;
      },
    });

  }

  openNewRequestModal(): void {
    const modalRef = this.modalService.open(NewRequestComponent, {
      size: 'lg',
      backdrop: 'static',
    });

    modalRef.componentInstance.prfyear = this.prfyear;
    modalRef.componentInstance.groupcode = this.groupcode;
    modalRef.componentInstance.custname = this.custname;
    modalRef.componentInstance.prfuser = this.prfuser;
    modalRef.result.then((result) => {
      if (result === true) {
        this.loadRequests();
      }
    });
  }

  toggleDetails(index: number) {
    this.expandedRowIndex = this.expandedRowIndex === index ? null : index;
  }

  openCancelRequestModal(ticketid: any): void {
    const modalRef = this.modalService.open(CancelRequestComponent, {
      size: 'lg',
      backdrop: 'static',
    });

    modalRef.componentInstance.prfyear = this.prfyear;
    modalRef.componentInstance.groupcode = this.groupcode;
    modalRef.componentInstance.ticketid = ticketid;
    modalRef.componentInstance.prfuser = this.prfuser;
    modalRef.result.then((result) => {
      if (result === true) {
        this.loadRequests();
      }
    });
  }

  openComment(comment: string) {
    const modalRef = this.modalService.open(CommentsModalComponent);
    modalRef.componentInstance.comment = comment;
  }

  formatDate(value: string): string {
    return formatDate(value);
  }

  navigateToDashboard(): void {
   this.router.navigate(['/dboard']);
  }
}
